import React, { useState } from 'react';
import { Container, Nav, Navbar, Form } from 'react-bootstrap';
import styled from 'styled-components';
import logo from '../assets/ttshlogo.png';
import { useTranslation } from 'react-i18next';

const Styles = styled.div`
small {
  color:#a6192e;
  font-weight:500;
} 

.navigation-bar {
  z-index:9;
  position:relative
}
 
.langCheck {
  position:absolute;
  top:0;
  left:0;
  font-size:8px;
  background-color:red;
  width:auto;
  z-index:99999;
  display:none;
}

`;


const NavigationBar = () => {
  const { t, i18n } = useTranslation();
  const [nameLang, setLang] = useState('en'); // constructor + prop

  const handlenameLangChange = (e) => {
    setLang(e.target.value)  // Set Value
    // console.log("handleName Change : "+e.target.value);
    i18n.changeLanguage(e.target.value);
  }

  return (
    <Styles>
      <div className="langCheck">
        {t('mainpage-header.1')} <br />
        {t('mainpage-btn.1')}<br />
        {t('mainpage-btn.2')}<br />
        {t('mainpage-btn.3')}<br />
      </div>
      <Container className="navigation-bar animate__animated animate__fadeInDown animate__faster">
        <Navbar bg="white" expand="lg">
          <Navbar.Toggle aria-controls="basic-navar-nbav" />
          <Navbar.Brand href="/" className="mx-auto"><img src={logo} alt="Tan Tock Seng Hospital" width="208" /></Navbar.Brand>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              <Nav.Link href="https://www.ttsh.com.sg/Pages/default.aspx">
                <small>
                  {/* Home */} 
                  {t('mainpage-btn.4')}
                </small>
              </Nav.Link>
              <Nav.Link href="/WardVisitor">
                <small>
                  {/* Ward Visitor */} 
                  {t('mainpage-btn.1')}
                </small>
              </Nav.Link>
              <Nav.Link href="/OutpatientVisitor">
                <small>
                  {/* Accompanying Outpatient */}
                  {t('mainpage-btn.2')}
                </small>
              </Nav.Link>
              <Nav.Link href="/DayVisitor">
                <small>
                  {/* Accompanying Day Procedure Patient */} 
                  {t('mainpage-btn.3')}
                </small>
              </Nav.Link>
            </Nav>
            <Form>
              <Form.Control id="select-language" as="select" className="ml-3" size="sm" onChange={handlenameLangChange} value={nameLang}>
                <option value="en">English</option>
                <option value="cn">Chinese</option>
                <option value="ml">Malay</option>
                <option value="tm">Tamil</option>
              </Form.Control>
            </Form>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </Styles >
  );
};


export default NavigationBar;